import React, { useState } from 'react';

const GDPRPopup = ({ onAccept, onDecline }) => {
  const [accepted, setAccepted] = useState(false);

  const handleAccept = () => {
    if (accepted) {
      onAccept();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <h2 className="text-2xl font-bold mb-4 text-gray-900">
            GDPR Compliance - Passenger Data Handling
          </h2>
          
          <div className="mb-6 text-gray-700 space-y-4">
            <p className="font-semibold">
              By using this application, you acknowledge and agree to the following terms regarding passenger information handling:
            </p>
            
            <div className="space-y-3">
              <h3 className="font-semibold text-lg">Data Collection and Processing</h3>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  We collect and process passenger personal data including names, contact information, flight details, and travel documents in accordance with GDPR (General Data Protection Regulation) requirements.
                </li>
                <li>
                  Personal data is processed solely for the purpose of providing VIP airport services, operational reporting, and service management.
                </li>
                <li>
                  All data processing is conducted with appropriate technical and organizational measures to ensure security and confidentiality.
                </li>
              </ul>

              <h3 className="font-semibold text-lg mt-4">Your Rights Under GDPR</h3>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  <strong>Right to Access:</strong> You have the right to access personal data we hold about passengers.
                </li>
                <li>
                  <strong>Right to Rectification:</strong> You can request correction of inaccurate or incomplete data.
                </li>
                <li>
                  <strong>Right to Erasure:</strong> You can request deletion of personal data when it's no longer necessary for the purposes collected.
                </li>
                <li>
                  <strong>Right to Restriction:</strong> You can request restriction of processing in certain circumstances.
                </li>
                <li>
                  <strong>Right to Data Portability:</strong> You can request transfer of data in a structured, machine-readable format.
                </li>
              </ul>

              <h3 className="font-semibold text-lg mt-4">Data Storage and Retention</h3>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  Passenger data is stored securely with access limited to authorized personnel only.
                </li>
                <li>
                  Data is retained only for as long as necessary to fulfill service obligations and legal requirements.
                </li>
                <li>
                  We implement industry-standard security measures to protect against unauthorized access, alteration, or disclosure.
                </li>
              </ul>

              <h3 className="font-semibold text-lg mt-4">Third Party Sharing</h3>
              <ul className="list-disc pl-5 space-y-2">
                <li>
                  Personal data may be shared with airlines, airport authorities, and service providers only when necessary to deliver requested services.
                </li>
                <li>
                  We do not sell or trade passenger personal data to third parties.
                </li>
              </ul>

              <h3 className="font-semibold text-lg mt-4">Contact and Complaints</h3>
              <p>
                For any questions, concerns, or to exercise your GDPR rights, please contact your data protection officer or supervisory authority.
              </p>
            </div>

            <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded">
              <p className="text-sm text-blue-900">
                <strong>Important:</strong> By accepting these terms, you confirm that you have read, understood, and agree to comply with GDPR regulations when handling passenger information through this application.
              </p>
            </div>
          </div>

          <div className="mb-6">
            <label className="flex items-start space-x-3 cursor-pointer">
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
                className="mt-1 h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <span className="text-sm text-gray-700">
                I have read and accept the GDPR compliance terms for passenger data handling
              </span>
            </label>
          </div>

          <div className="flex gap-4">
            <button
              onClick={handleAccept}
              disabled={!accepted}
              className={`flex-1 py-3 px-4 rounded-lg font-semibold transition-colors ${
                accepted
                  ? 'bg-blue-600 text-white hover:bg-blue-700'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              Accept and Continue
            </button>
            <button
              onClick={onDecline}
              className="flex-1 py-3 px-4 bg-red-600 text-white rounded-lg font-semibold hover:bg-red-700 transition-colors"
            >
              Decline and Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GDPRPopup;
